import type { StyledButtonRoundedProps } from 'apps/shared/ui/button-rounded/button-rounded.styled';
import { StyledButtonRounded } from 'apps/shared/ui/button-rounded/button-rounded.styled';
import { Loader } from 'semantic-ui-react';

interface ButtonWithIconRoundedProps {
  icon?: React.ReactElement;
  text: string;
  onClick?: () => unknown;
  isDisabled?: boolean;
  isOutlined?: boolean;
  isLoading?: boolean;
  spacingSizeHorizontal?: StyledButtonRoundedProps['$sizeHorizontal'];
  spacingSizeVertical?: StyledButtonRoundedProps['$sizeHorizontal'];
  variant?: StyledButtonRoundedProps['$variant'];
  isFullWidth?: boolean;
}

const ButtonRounded = (props: ButtonWithIconRoundedProps) => {
  const {
    icon,
    text,
    onClick,
    isDisabled = false,
    isOutlined = false,
    isLoading = false,
    spacingSizeHorizontal = 'small',
    spacingSizeVertical = 'small',
    variant = 'primary',
    isFullWidth = false,
  } = props;

  const handleClick = () => {
    if (isDisabled) return;
    onClick?.();
  };

  return (
    <StyledButtonRounded
      $disabled={isDisabled}
      $outlined={isOutlined}
      $isLoading={isLoading}
      $withIcon={!!icon}
      $sizeHorizontal={spacingSizeHorizontal}
      $sizeVertical={spacingSizeVertical}
      $variant={variant}
      $isFullWidth={isFullWidth}
      className="button-rounded-wrapper"
    >
      <button className="button" type="button" onClick={handleClick}>
        <div className="button-content">
          {icon}
          {text}
        </div>
      </button>

      <div className="loader">
        <Loader active inline size="tiny" />
      </div>
    </StyledButtonRounded>
  );
};

export default ButtonRounded;
